import { Link } from 'react-router-dom';
import { useScrollAnimation } from '@/hooks/useScrollAnimation';
import { TattooPathDrawing, DecorativeRule, BotanicalCorner } from '@/components/feature/DrawingLines';

export default function CtaSection() {
  const { ref, visible } = useScrollAnimation(0.2);

  return (
    <section className="relative py-36 md:py-48 overflow-hidden" ref={ref}>
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/1140edaf77f6f6e189787b1bcb01c0cb.jpg"
          alt="선율 Studio Interior"
          className="w-full h-full object-cover object-top"
          style={{
            transform: visible ? 'scale(1)' : 'scale(1.08)',
            transition: 'transform 1.5s cubic-bezier(0.16, 1, 0.3, 1)',
          }}
        />
        <div className="absolute inset-0 bg-black/65" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-black/20" />
      </div>

      {/* Botanical corners on dark overlay */}
      <BotanicalCorner position="top-left" color="rgba(201,169,110,0.18)" size={200} />
      <BotanicalCorner position="bottom-right" color="rgba(201,169,110,0.15)" size={180} />

      {/* Animated border lines */}
      <div className="absolute inset-8 md:inset-16 border border-white/10 pointer-events-none z-10"
        style={{
          opacity: visible ? 1 : 0,
          transition: 'opacity 1s ease-out',
          transitionDelay: '600ms',
        }}
      />

      <div className="relative z-20 max-w-[1440px] mx-auto px-8 md:px-16 text-center">
        <div
          className="transition-all duration-700 ease-out"
          style={{
            opacity: visible ? 1 : 0,
            transform: visible ? 'translateY(0)' : 'translateY(30px)',
            transitionDelay: '100ms',
          }}
        >
          <div className="flex items-center justify-center gap-4 mb-8">
            <div className="w-12 h-px bg-white/30" />
            <p className="text-xs tracking-[0.4em] uppercase text-white/50">Join 선율</p>
            <div className="w-12 h-px bg-white/30" />
          </div>
        </div>

        <div
          className="transition-all duration-900 ease-out"
          style={{
            opacity: visible ? 1 : 0,
            transform: visible ? 'translateY(0)' : 'translateY(40px)',
            transitionDelay: '250ms',
            transitionDuration: '900ms',
          }}
        >
          <h2
            className="text-4xl md:text-6xl font-thin text-white tracking-tight mb-6 leading-tight"
            style={{ fontFamily: "'Cormorant Garamond', serif" }}
          >
            Where Lines<br />
            <span className="text-white/50">Become Art.</span>
          </h2>
        </div>

        {/* Tattoo path drawing — centered */}
        <div
          className="flex justify-center mb-6 transition-all duration-700 ease-out"
          style={{ opacity: visible ? 1 : 0, transitionDelay: '400ms' }}
        >
          <TattooPathDrawing color="rgba(201,169,110,0.45)" width={180} height={130} />
        </div>

        <div
          className="transition-all duration-700 ease-out"
          style={{
            opacity: visible ? 1 : 0,
            transform: visible ? 'translateY(0)' : 'translateY(20px)',
            transitionDelay: '450ms',
          }}
        >
          <p className="text-sm text-white/45 mb-8 max-w-md mx-auto leading-relaxed">
            선율과 함께 당신만의 프리미엄 타투 스튜디오를 시작하세요.
          </p>
        </div>

        {/* Decorative rule */}
        <div
          className="max-w-xs mx-auto mb-10 transition-all duration-700 ease-out"
          style={{ opacity: visible ? 1 : 0, transitionDelay: '500ms' }}
        >
          <DecorativeRule color="#C9A96E" delay={0.5} />
        </div>

        <div
          className="flex flex-col gap-3 sm:flex-row sm:gap-4 justify-center w-full px-0 transition-all duration-700 ease-out"
          style={{
            opacity: visible ? 1 : 0,
            transform: visible ? 'translateY(0)' : 'translateY(20px)',
            transitionDelay: '600ms',
          }}
        >
          <Link
            to="/community/inquiry"
            className="inline-flex items-center justify-center w-full sm:w-auto px-12 py-4 bg-white text-[#1A1A1A] text-xs tracking-[0.2em] uppercase font-medium hover:bg-white/90 transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            가맹 문의하기
            <i className="ri-arrow-right-line ml-2" />
          </Link>
          <Link
            to="/portfolio"
            className="inline-flex items-center justify-center w-full sm:w-auto px-12 py-4 border border-white/50 text-white text-xs tracking-[0.2em] uppercase font-light hover:bg-white/10 hover:border-white transition-all duration-300 cursor-pointer whitespace-nowrap backdrop-blur-sm"
          >
            포트폴리오 보기
          </Link>
        </div>
      </div>
    </section>
  );
}
